import React from 'react';
import { useSelector } from "react-redux";
export default function Navbar({ onMenuClick }) {
    const InviteData = useSelector((state) => state?.persistedReducer?.forms?.inviteData);
    const { fullName } = InviteData ?? {};
    return (
        <nav className="employee-form-navbar">
            <div className="container-fluid">              
                <div className="nav-logo">
                    <img src={require("assets/img/reactlogo.png")} alt="..." />
                </div>
                <div className="empl-name">
                    Welcome <span>{(fullName) ? "to" + " " + fullName : ''}</span>
                </div>
                 {/* Hamburger icon for mobile */}
                <div className="menu-icon" onClick={onMenuClick}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </nav>
    )
}
